import { useTranslation } from 'react-i18next'
import { ArrowLeft } from 'lucide-react'
import { LocalizedLink } from '@/components/LocalizedLink'
import { LightField } from '@/components/glass/LightField'
import { GlassStack } from '@/components/glass/GlassStack'
import { cssVars } from '@/lib/utils'

/**
 * Pagina non trovata: il 404 inciso dietro le tre lastre di vetro del marchio, che lo piegano.
 * `.site` anche qui: RouteErrorBoundary la mostra pure dal root, fuori dal layout del sito.
 */
export function NotFound() {
  const { t } = useTranslation()
  return (
    <main id="main-content" data-surface="dark" className="site section relative flex min-h-svh items-center overflow-clip pb-24 pt-36">
      <LightField variant="abyss" flow />
      <div className="shell relative text-center">
        <div className="relative mx-auto grid max-w-3xl place-items-center">
          <p className="not-found-code" aria-hidden="true">
            404
          </p>
          <GlassStack className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 [--stack:min(24rem,70vw)]" />
        </div>
        <h1 className="t-display enter mx-auto mt-6 max-w-2xl" style={cssVars({ '--i': 3 })}>
          {t('notFound.title')}
        </h1>
        <p className="t-lead enter mx-auto mt-6 max-w-md" style={cssVars({ '--i': 5 })}>
          {t('notFound.description')}
        </p>
        <LocalizedLink to="home" data-glow className="btn btn-primary enter mt-10" style={cssVars({ '--i': 7 })}>
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          {t('buttons.backToHome')}
        </LocalizedLink>
      </div>
    </main>
  )
}
